import axios from "axios";

export function createAccounts(data) {
  let configAccount = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts`,
    data: data
  };

  return axios(configAccount);
}

export function createBusinesses(data) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${data.accountId}/businesses`,
    data: data
  };
  return axios(configBusiness);
}

export function createRichmenu(accountId ,data) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(configBusiness);
}

export function createDefaultItem(accountId) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/default-item`,
    data: {}
  };
  return axios(configBusiness);
}

export function insertQrcode(data, type) {
  let {
      shopId,
      tableNumber
  } = data;
  var config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${shopId}/qrcode`,
    data: {
        tableNumber
    }
  };
  return axios(config);
}


export function updateCode(accountId, type) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/shops/${accountId}/code`,
    data: {}
  };
  return axios(configBusiness);
}

export function toShortUrl(url) {
  let configBusiness = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/apis/shorturl`,
    data: {url}
  };
  return axios(configBusiness);
}
